module.exports = __webpack_public_path__ + "media/assets/icons/chevrons/chevron-up-067454530ea048467e080d2df2e07eb6.svg";